import React, { Component } from 'react'
import Modal from 'react-modal'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import PaymentCardListPageUI from './PaymentCardListPageUI.js'

class PaymentCardListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      paymentCardList: null,
      //
      successMsg: null,
      errorList: null,
      updateMode: false,
      deleteMode: false,
      submitted: false,
      selectedCount: 0,
    }
  }

  render() {
    return (
      <PaymentCardListPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        paymentCardList={this.state.paymentCardList}
        // form
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={(errorList) => {this.setState({errorList: errorList})}}
        // modes
        selectedCount={this.state.selectedCount}
        updateMode={this.state.updateMode}
        deleteMode={this.state.deleteMode}
        submitted={this.state.submitted}
        // events
        onRowClick={this.onRowClick}
        onRefreshClick={this.onRefreshClick}
        onCreateClick={this.onCreateClick}
        onUpdateClick={this.onUpdateClick}
        onDeleteClick={this.onDeleteClick}
        onConfirmCreateClick={this.onConfirmCreateClick}
        onConfirmUpdateClick={this.onConfirmUpdateClick}
        onConfirmDeleteClick={this.onConfirmDeleteClick}
        onCancelClick={this.onCancelClick}
      />

    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getPaymentCards(context)
    this.getMessages(context)
    // https://stackoverflow.com/questions/48269381/warning-react-modal-app-element-is-not-defined-please-use-modal-setappeleme
    Modal.setAppElement('body')
  }

  getPaymentCards(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/paymentCards`,
      cacheKey: CacheKeys.PaymentCards(context.session.accountId),
      callback: this.getPaymentCardsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getPaymentCardsCallback = (response) => {
    response.paymentCardList && response.paymentCardList.forEach(customer => {
      customer.selected = false
    })
    this.setState({ paymentCardList: response.paymentCardList})
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.PaymentCards(context.session.accountId))
    this.setState({errorList: null, paymentCardList: null})
    this.getPaymentCards(context)
  }

  onRowClick = event => {
    let customerId = event.currentTarget.getAttribute('data-row-id')
    let paymentCardList = this.state.paymentCardList
    paymentCardList
      .filter(customer => customer.customerId === customerId)
      .forEach(customer => {
      customer.selected = !Boolean(customer.selected)
    })

    this.setState({paymentCardList : paymentCardList})
  }

  getMessages(context) {
    let arr = [
      'c_payment_cards',
      'c_create_card',
      'c_refresh',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_acc_cards', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default PaymentCardListPageSF
